import { call, put, takeLatest } from "redux-saga/effects";
import { studentAPI } from "../../../services/student/index"
import { fetchStudentCourse, FETCH_STUDENT_COURSE} from "../../actions/student.action"

function* handleFetchStudentCourse(action) {
  try {
    const { data : resData} = yield call(studentAPI.fetchStudentCourse, action.payload);
    //extract the data here     
    yield put(fetchStudentCourse.success({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  } catch (e) {
    const {data:resData} = e
    yield put(fetchStudentCourse.failure({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  }
}

function* fetchStudentCourseSaga() {
  yield takeLatest(FETCH_STUDENT_COURSE.REQUEST, handleFetchStudentCourse);
}

export default fetchStudentCourseSaga;
